import React, { useEffect, useRef, useState } from "react";

const Icon = ({ d, size = 20, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth={1.8} strokeLinecap="round"
    strokeLinejoin="round" className={className}>
    <path d={d} />
  </svg>
);
const ICONS = {
  check: "M20 6L9 17l-5-5",
  x: "M18 6L6 18M6 6l12 12",
  whatsapp: "M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z",
};

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;600;700;800&family=JetBrains+Mono:wght@400;600&display=swap');

  .vp-title {
    background: linear-gradient(110deg, #fbbf24 35%, #a78bfa 50%, #fbbf24 65%);
    background-size: 200% 100%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: vp-shimmer 8s linear infinite;
  }

  @keyframes jdc-gradient-shift {
    0%, 100% { background-position: 0% 50%; }
    50%       { background-position: 100% 50%; }
  }
  .jdc-divider {
    height: 2px;
    background: linear-gradient(90deg, transparent, rgba(249,115,22,0.4) 20%, rgba(168,85,247,0.5) 50%, rgba(6,182,212,0.4) 80%, transparent);
  }
  @keyframes jdc-fadeUp {
    from { opacity: 0; transform: translateY(20px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  .jdc-fade   { animation: jdc-fadeUp 0.6s ease forwards; }
  .jdc-fade-1 { animation-delay: 0.1s; opacity: 0; }
  .jdc-fade-2 { animation-delay: 0.2s; opacity: 0; }
  .jdc-fade-3 { animation-delay: 0.3s; opacity: 0; }
  .jdc-fade-4 { animation-delay: 0.4s; opacity: 0; }
  .jdc-fade-5 { animation-delay: 0.5s; opacity: 0; }

  @keyframes jdc-highlight-bg {
    0%, 100% { background-position: 0% 50%; }
    50%       { background-position: 100% 50%; }
  }
  .jdc-highlight-bg { background-size: 200% 200%; animation: jdc-highlight-bg 8s ease infinite; }

  @keyframes jdc-speed-pulse {
    0%, 100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(249,115,22,0.7); }
    50%       { transform: scale(1.05); box-shadow: 0 0 0 10px rgba(249,115,22,0); }
  }
  .jdc-speed-badge { animation: jdc-speed-pulse 2.5s ease-in-out infinite; }

  .jdc-feature-card { transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1); }
  .jdc-feature-card:hover { transform: translateY(-10px) scale(1.03); }

  .jdc-badge { transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1); }
  .jdc-badge:hover { transform: translateY(-4px) scale(1.05); }
  @keyframes jdc-badge-pop {
    0%   { transform: scale(0.8); opacity: 0; }
    100% { transform: scale(1); opacity: 1; }
  }
  .jdc-badge-anim { animation: jdc-badge-pop 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) backwards; }

  .jdc-bento-card { transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1); }
  .jdc-bento-card:hover { transform: translateY(-6px); }

  /* ── Bento accent animations ── */
  @keyframes cdx-scan-anim {
    0%   { transform: translateY(0px); opacity: 1; }
    90%  { opacity: 0.6; }
    100% { transform: translateY(40px); opacity: 0; }
  }
  .cdx-scan { animation: cdx-scan-anim 2.2s ease-in-out infinite; }

  @keyframes cdx-node-pulse {
    0%, 100% { opacity: 0.4; }
    50%       { opacity: 1; }
  }
  .cdx-node-p { animation: cdx-node-pulse 2s ease-in-out infinite; }

  @keyframes cdx-connect-anim {
    from { stroke-dashoffset: 80; opacity: 0.2; }
    to   { stroke-dashoffset: 0; opacity: 1; }
  }
  .cdx-connector { stroke-dasharray: 80; animation: cdx-connect-anim 1.6s ease-in-out infinite alternate; }

  @keyframes cdx-radar-spin {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
  }
  .cdx-radar-sweep { animation: cdx-radar-spin 3s linear infinite; transform-origin: 36px 28px; }

  @keyframes cdx-pipe-pulse {
    0%, 100% { opacity: 0.35; }
    50%       { opacity: 1; }
  }
  .cdx-pipe-node { animation: cdx-pipe-pulse 1.8s ease-in-out infinite; }

  /* ── Process flow accent animations ── */
  @keyframes cdx-grid-draw {
    from { stroke-dashoffset: 200; opacity: 0; }
    to   { stroke-dashoffset: 0;   opacity: 1; }
  }
  .cdx-grid-line { stroke-dasharray: 200; animation: cdx-grid-draw 2s ease-out infinite alternate; }

  @keyframes cdx-block-in {
    0%   { transform: translateY(-6px); opacity: 0; }
    100% { transform: translateY(0);    opacity: 1; }
  }
  .cdx-blk1 { animation: cdx-block-in 0.6s ease-out 0.0s infinite alternate; }
  .cdx-blk2 { animation: cdx-block-in 0.6s ease-out 0.2s infinite alternate; }
  .cdx-blk3 { animation: cdx-block-in 0.6s ease-out 0.4s infinite alternate; }

  @keyframes cdx-ring-fill {
    from { stroke-dashoffset: 88; }
    to   { stroke-dashoffset: 16; }
  }
  .cdx-score-ring { stroke-dasharray: 88; animation: cdx-ring-fill 2s cubic-bezier(0.22,1,0.36,1) infinite alternate; }

  @keyframes cdx-check-draw {
    from { stroke-dashoffset: 40; opacity: 0; }
    to   { stroke-dashoffset: 0;  opacity: 1; }
  }
  .cdx-check-path { stroke-dasharray: 40; animation: cdx-check-draw 1s ease-out infinite alternate; }

  .cdx-process-card { transition: all 0.3s ease; }
  .cdx-process-card:hover { transform: translateY(-6px); }

  /* ── Comparison ── */
  .jdc-comparison-card { position: relative; overflow: hidden; transition: all 0.3s ease; }
  .jdc-comparison-card::before {
    content: ''; position: absolute; top: 0; left: -100%; width: 100%; height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.03), transparent);
    transition: left 0.5s ease;
  }
  .jdc-comparison-card:hover::before { left: 100%; }
  .jdc-comparison-card:hover { transform: translateY(-4px); }
  .jdc-comparison-item { transition: all 0.2s ease; }
  .jdc-comparison-item:hover { transform: translateX(4px); }
  @keyframes jdc-check-pop {
    0%   { transform: scale(0); opacity: 0; }
    50%  { transform: scale(1.2); }
    100% { transform: scale(1); opacity: 1; }
  }
  .jdc-check-icon { animation: jdc-check-pop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) backwards; }
  .jdc-x-icon:hover { animation: jdc-x-shake 0.4s ease-in-out; }
  @keyframes jdc-x-shake {
    0%, 100% { transform: rotate(0deg); }
    25%       { transform: rotate(-3deg); }
    75%       { transform: rotate(3deg); }
  }

  /* ── Timeline ── */
  @keyframes cdx-tl-line-grow {
    from { transform: scaleX(0); }
    to   { transform: scaleX(1); }
  }
  .cdx-h-timeline-line { animation: cdx-tl-line-grow 2s cubic-bezier(0.22,1,0.36,1) 0.4s both; transform-origin: left; }

  @keyframes cdx-glow-trail {
    0%, 100% { opacity: 0.3; }
    50%       { opacity: 0.7; }
  }
  .cdx-glow-trail { animation: cdx-glow-trail 3s ease-in-out infinite; }

  .cdx-tl-card { transition: all 0.3s ease; }
  .cdx-tl-card:hover { transform: translateY(-6px); }

  @keyframes jdc-timeline-draw {
    from { height: 0%; }
    to   { height: 100%; }
  }
  .jdc-timeline-line { animation: jdc-timeline-draw 1.5s cubic-bezier(0.22, 1, 0.36, 1) 0.3s both; }
  .jdc-timeline-card { transition: all 0.3s ease; }
  .jdc-timeline-card:hover { transform: translateX(6px); }
`;

// ─── DATA ─────────────────────────────────────────────────────────────────────
const BADGES = [
  "Role Blueprinting", "Skill Taxonomy Mapping", "Seniority Calibration",
  "Resume Structuring", "Interview Scorecards", "Hiring Workflow Alignment",
  "Compensation Benchmarking", "Bias Detection",
];
const FEATURES = [
  { icon: "📄", title: "Document Intelligence", text: "Generate precise job descriptions from role blueprints, then parse incoming JDs and resumes into structured, comparable signals — eliminating manual extraction at every stage.", color: "orange" },
  { icon: "🎯", title: "Candidate Intelligence", text: "Score JD-to-candidate alignment across skills, experience depth, and role fit — then screen at scale with AI-driven shortlisting before a human reviews a single profile.", color: "violet" },
  { icon: "🎙️", title: "Interview Intelligence", text: "Conduct AI-powered mock interviews, auto-generate competency-based question sets, and equip every interviewer with structured scoring rubrics calibrated to the role.", color: "cyan" },
  { icon: "⚙️", title: "Workflow Automation", text: "Automate end-to-end hiring workflows — from requisition to offer — with structured approval chains, role-based permissions, and zero manual coordination overhead.", color: "emerald" },
  { icon: "🔐", title: "Hiring Governance", text: "Enforce compliance at every stage — manage security clearances, maintain audit-ready approval trails, and standardize hiring controls across teams, geographies, and seniority levels.", color: "amber" },
  { icon: "📊", title: "Analytics & Enablement", text: "Surface hiring funnel insights, benchmark decision quality, and continuously upskill your hiring teams — turning every completed hire into intelligence for the next.", color: "pink" },
];
const FLOW_STEPS = [
  { label: "DEFINE", color: "#fb923c", description: "Capture role intent, seniority, team context, and required competencies into a structured role definition layer." },
  { label: "STRUCTURE", color: "#a78bfa", description: "AI assembles a complete role blueprint — JD copy, skill taxonomy, and evaluation framework — from your inputs." },
  { label: "MATCH", color: "#22d3ee", description: "Parse incoming resumes and score each candidate against the role blueprint using objective, skill-based criteria." },
  { label: "DECIDE", color: "#34d399", description: "Surface ranked shortlists, skill gap reports, and interview guides — ready for confident, data-backed hiring decisions." },
];
const COMPARISON = {
  title: "Hiring Instinct vs. Structured Hiring Intelligence",
  beforeTitle: "Without Codex",
  afterTitle: "With HEKA Codex",
  before: [
    "Role requirements scattered across emails, docs, and memory",
    "JDs rewritten from scratch — inconsistent every single hire",
    "Resumes evaluated subjectively with no shared rubric",
    "Bias and ambiguity slip through undetected at every stage",
    "Interview questions improvised — evaluation is guesswork",
  ],
  after: [
    "Unified role intelligence from first brief to final decision",
    "Structured, reusable blueprints across every role and team",
    "Skill-based resume parsing with objective match scoring",
    "Bias detection and clarity audits built into every workflow",
    "Competency-mapped interview frameworks generated automatically",
  ],
};
const TIMELINE_STEPS = [
  { step: "01", title: "Define the Role", subtitle: "Role Blueprint Engine", text: "Translate hiring intent into a structured role blueprint — capturing required competencies, seniority signals, and success criteria before a single document is written.", color: "#f97316", nodeColor: "#f97316", glowColor: "rgba(249,115,22,0.12)", border: "rgba(249,115,22,0.25)" },
  { step: "02", title: "Structure & Parse", subtitle: "JD Creator · JD Parser · Resume Parser", text: "Generate a precise job description from the role blueprint, then parse incoming JDs and resumes into clean, comparable data signals.", color: "#a855f7", nodeColor: "#a855f7", glowColor: "rgba(168,85,247,0.12)", border: "rgba(168,85,247,0.25)" },
  { step: "03", title: "Match & Evaluate", subtitle: "Match Engine · AI Screening · AI Interview · Skill Gap Analyzer", text: "Score candidates against role criteria, screen profiles at scale, conduct structured AI interviews, and surface skill gaps — all in one pass.", color: "#22d3ee", nodeColor: "#22d3ee", glowColor: "rgba(34,211,238,0.12)", border: "rgba(34,211,238,0.25)" },
  { step: "04", title: "Optimize & Align", subtitle: "Interview Intelligence · Bias Engine", text: "Build structured interview frameworks tailored to the role, detect bias risks in evaluations, and align every assessor to the same objective rubric.", color: "#10b981", nodeColor: "#10b981", glowColor: "rgba(16,185,129,0.12)", border: "rgba(16,185,129,0.25)" },
  { step: "05", title: "Decide with Confidence", subtitle: "Hiring Workflow Structuring", text: "Standardize the end-to-end hiring workflow — from ranked shortlists to decision-ready reports — building reusable intelligence that improves every future hire.", color: "#f59e0b", nodeColor: "#f59e0b", glowColor: "rgba(245,158,11,0.12)", border: "rgba(245,158,11,0.25)" },
];

// ─── BENTO ACCENT SVGs ────────────────────────────────────────────────────────
const AccentScaleUp  = () => (
  <svg width="80" height="60" viewBox="0 0 80 60">
    <rect x="8" y="4" width="38" height="50" rx="3" fill="none" stroke="rgba(251,146,60,0.3)" strokeWidth="1.5" />
    {[0, 1, 2, 3].map(i => (
      <rect key={i} x="14" y={12 + i * 10} width={[22, 28, 16, 24][i]} height="5" rx="2" fill="rgba(251,146,60,0.3)" />
    ))}
    <rect x="8" y="4" width="38" height="2.5" rx="1" fill="rgba(251,146,60,0.95)" className="cdx-scan"
      style={{ filter: "drop-shadow(0 0 3px rgba(251,146,60,0.8))" }} />
    {[0, 1, 2].map(i => (
      <g key={i}>
        <line x1="48" y1={16 + i * 14} x2="56" y2={20 + i * 14} stroke="rgba(251,146,60,0.3)" strokeWidth="1" />
        <circle cx="60" cy={20 + i * 14} r="4" fill="none" stroke="rgba(251,146,60,0.6)" strokeWidth="1.5"
          className="cdx-node-p" style={{ animationDelay: `${i * 0.3}s` }} />
      </g>
    ))}
  </svg>
);

const AccentEnterprise  = () => (
  <svg width="80" height="60" viewBox="0 0 80 60">
    <circle cx="16" cy="30" r="10" fill="none" stroke="rgba(168,85,247,0.4)" strokeWidth="1.5" />
    <circle cx="16" cy="30" r="5" fill="rgba(168,85,247,0.18)" className="cdx-node-p" />
    <circle cx="64" cy="30" r="10" fill="none" stroke="rgba(168,85,247,0.4)" strokeWidth="1.5" />
    <circle cx="64" cy="30" r="5" fill="rgba(168,85,247,0.18)" className="cdx-node-p" style={{ animationDelay: "0.5s" }} />
    <line x1="26" y1="30" x2="54" y2="30" stroke="rgba(168,85,247,0.65)" strokeWidth="1.5" className="cdx-connector" />
    <text x="40" y="24" textAnchor="middle" fill="rgba(168,85,247,0.85)" fontSize="9" fontFamily="monospace" fontWeight="bold">94%</text>
    <circle cx="16" cy="30" r="14" fill="none" stroke="rgba(168,85,247,0.1)" strokeWidth="1" className="cdx-node-p" style={{ animationDelay: "0.2s" }} />
    <circle cx="64" cy="30" r="14" fill="none" stroke="rgba(168,85,247,0.1)" strokeWidth="1" className="cdx-node-p" style={{ animationDelay: "0.7s" }} />
  </svg>
);

const AccentAgency  = () => (
  <svg width="80" height="60" viewBox="0 0 80 60">
    <circle cx="40" cy="30" r="24" fill="none" stroke="rgba(34,211,238,0.1)" strokeWidth="1" />
    <circle cx="40" cy="30" r="16" fill="none" stroke="rgba(34,211,238,0.16)" strokeWidth="1" />
    <circle cx="40" cy="30" r="8" fill="none" stroke="rgba(34,211,238,0.25)" strokeWidth="1" />
    <g className="cdx-radar-sweep" style={{ transformOrigin: "40px 30px" }}>
      <line x1="40" y1="30" x2="40" y2="6" stroke="rgba(34,211,238,0.75)" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M40,30 L40,6 A24,24 0 0,1 64,42 Z" fill="rgba(34,211,238,0.05)" />
    </g>
    {[0, 1, 2, 3, 4].map(i => {
      const a = (i * 72 - 90) * Math.PI / 180, r = [18, 13, 22, 11, 17][i];
      return <circle key={i} cx={40 + r * Math.cos(a)} cy={30 + r * Math.sin(a)} r="2.5"
        fill="rgba(34,211,238,0.75)" className="cdx-node-p" style={{ animationDelay: `${i * 0.2}s` }} />;
    })}
  </svg>
);

const AccentConsulting = () => (
  <svg width="80" height="60" viewBox="0 0 80 60">
    {[0, 1, 2, 3].map(i => (
      <g key={i}>
        <circle cx={12 + i * 18} cy="30" r="7"
          fill="rgba(16,185,129,0.1)" stroke="rgba(16,185,129,0.55)" strokeWidth="1.5"
          className="cdx-pipe-node" style={{ animationDelay: `${i * 0.25}s` }} />
        {i < 3 && <line x1={19 + i * 18} y1="30" x2={23 + i * 18} y2="30"
          stroke="rgba(16,185,129,0.4)" strokeWidth="1.5" className="cdx-connector" style={{ animationDelay: `${i * 0.15}s` }} />}
      </g>
    ))}
    {["JD", "Parse", "Match", "Hire"].map((lbl, i) => (
      <text key={i} x={12 + i * 18} y="46" textAnchor="middle"
        fill="rgba(16,185,129,0.55)" fontSize="6.5" fontFamily="monospace">{lbl}</text>
    ))}
    {[0, 1, 2, 3].map(i => (
      <line key={i} x1={12 + i * 18} y1="23" x2={12 + i * 18} y2="14"
        stroke="rgba(16,185,129,0.2)" strokeWidth="1" strokeDasharray="2,2" />
    ))}
  </svg>
);

// ─── PROCESS FLOW ACCENT SVGs ─────────────────────────────────────────────────
// DEFINE — blueprint grid being drawn
const PfDefine = () => (
  <svg width="68" height="56" viewBox="0 0 68 56">
    {[0, 1, 2].map(i => (
      <line key={`h${i}`} x1="8" y1={12 + i * 12} x2="60" y2={12 + i * 12}
        stroke="rgba(251,146,60,0.4)" strokeWidth="1.2" className="cdx-grid-line"
        style={{ animationDelay: `${i * 0.2}s` }} />
    ))}
    {[0, 1, 2, 3].map(i => (
      <line key={`v${i}`} x1={8 + i * 17} y1="12" x2={8 + i * 17} y2="36"
        stroke="rgba(251,146,60,0.2)" strokeWidth="1" className="cdx-grid-line"
        style={{ animationDelay: `${0.1 + i * 0.15}s` }} />
    ))}
    <rect x="8" y="40" width="30" height="8" rx="2" fill="rgba(251,146,60,0.12)" stroke="rgba(251,146,60,0.45)" strokeWidth="1" />
    <rect x="42" y="40" width="18" height="8" rx="2" fill="rgba(251,146,60,0.08)" stroke="rgba(251,146,60,0.3)" strokeWidth="1" />
    <circle cx="60" cy="12" r="3.5" fill="rgba(251,146,60,0.75)" className="cdx-node-p" />
  </svg>
);

// STRUCTURE — three labeled blocks assembling top-down
const PfStructure = () => (
  <svg width="68" height="56" viewBox="0 0 68 56">
    <rect x="6" y="4" width="56" height="12" rx="2.5" fill="rgba(167,139,250,0.18)" stroke="rgba(167,139,250,0.5)" strokeWidth="1.5" className="cdx-blk1" />
    <rect x="6" y="21" width="42" height="11" rx="2.5" fill="rgba(167,139,250,0.13)" stroke="rgba(167,139,250,0.4)" strokeWidth="1.5" className="cdx-blk2" />
    <rect x="6" y="37" width="32" height="11" rx="2.5" fill="rgba(167,139,250,0.08)" stroke="rgba(167,139,250,0.3)" strokeWidth="1.5" className="cdx-blk3" />
    <text x="10" y="14" fill="rgba(167,139,250,0.8)" fontSize="6.5" fontFamily="monospace">JD COPY</text>
    <text x="10" y="30" fill="rgba(167,139,250,0.65)" fontSize="6.5" fontFamily="monospace">SKILL TAXONOMY</text>
    <text x="10" y="46" fill="rgba(167,139,250,0.5)" fontSize="6.5" fontFamily="monospace">EVAL FRAMEWORK</text>
  </svg>
);

// MATCH — match score ring with percentage
const PfMatch = () => (
  <svg width="68" height="56" viewBox="0 0 68 56">
    <circle cx="34" cy="28" r="20" fill="none" stroke="rgba(34,211,238,0.1)" strokeWidth="6" />
    <circle cx="34" cy="28" r="20" fill="none" stroke="rgba(34,211,238,0.65)" strokeWidth="6"
      strokeLinecap="round" className="cdx-score-ring"
      style={{ transform: "rotate(-90deg)", transformOrigin: "34px 28px" }} />
    <text x="34" y="25" textAnchor="middle" fill="rgba(34,211,238,0.9)" fontSize="11" fontFamily="monospace" fontWeight="bold">94</text>
    <text x="34" y="36" textAnchor="middle" fill="rgba(34,211,238,0.5)" fontSize="6" fontFamily="monospace">MATCH %</text>
  </svg>
);

// DECIDE — document with checkmark confirming decision
const PfDecide = () => (
  <svg width="68" height="56" viewBox="0 0 68 56">
    <rect x="8" y="4" width="38" height="44" rx="3" fill="rgba(52,211,153,0.07)" stroke="rgba(52,211,153,0.3)" strokeWidth="1.5" />
    <line x1="14" y1="16" x2="40" y2="16" stroke="rgba(52,211,153,0.22)" strokeWidth="1.5" />
    <line x1="14" y1="24" x2="36" y2="24" stroke="rgba(52,211,153,0.22)" strokeWidth="1.5" />
    <line x1="14" y1="32" x2="38" y2="32" stroke="rgba(52,211,153,0.22)" strokeWidth="1.5" />
    <circle cx="52" cy="40" r="12" fill="rgba(52,211,153,0.1)" stroke="rgba(52,211,153,0.5)" strokeWidth="1.5" />
    <path d="M45,40 L50,46 L59,33" fill="none" stroke="rgba(52,211,153,0.9)" strokeWidth="2.5"
      strokeLinecap="round" strokeLinejoin="round" className="cdx-check-path" />
  </svg>
);

// ─── COMPONENTS ───────────────────────────────────────────────────────────────

const FeatureGrid = () => (
  <section className="jdc-fade jdc-fade-2">
    <div className="text-center mb-14">
      <p className="text-xs font-bold tracking-widest uppercase text-orange-400 mb-3">Platform Capabilities</p>
      <h2 className="text-3xl font-bold text-slate-100 tracking-tight">The Full Stack of Hiring Intelligence</h2>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {FEATURES.map((f, i) => (
        <div key={i} className={`jdc-feature-card rounded-2xl border border-${f.color}-800/30 bg-gradient-to-br from-${f.color}-900/10 to-slate-900/50 p-7 hover:border-${f.color}-700/50 backdrop-blur-sm group`}>
          <div className="text-5xl mb-5">{f.icon}</div>
          <h3 className={`text-${f.color}-400 font-bold text-lg mb-3 tracking-tight group-hover:text-${f.color}-300 transition-colors`}>{f.title}</h3>
          <p className="text-slate-400 text-sm leading-relaxed group-hover:text-slate-300 transition-colors">{f.text}</p>
        </div>
      ))}
    </div>
  </section>
);

const BadgePills = () => (
  <section className="jdc-fade jdc-fade-3">
    <div className="text-center mb-12">
      <p className="text-xs font-bold tracking-widest uppercase text-violet-400 mb-3">System Capabilities</p>
      <h2 className="text-3xl font-bold text-slate-100 tracking-tight">Every Dimension of Hiring, Covered</h2>
    </div>
    <div className="flex flex-wrap gap-3 justify-center max-w-4xl mx-auto">
      {BADGES.map((b, i) => (
        <div key={i} className="jdc-badge jdc-badge-anim px-5 py-2.5 rounded-full bg-gradient-to-r from-orange-900/30 to-amber-900/30 border border-orange-700/40 text-orange-300 text-sm font-semibold backdrop-blur-sm hover:border-orange-500/60 hover:text-orange-200 cursor-default"
          style={{ animationDelay: `${i * 0.05}s` }}>{b}</div>
      ))}
    </div>
  </section>
);

// ── BENTO: accent sits above content in its own row — zero overlap ────────────
const BentoCards = () => (
  <section className="jdc-fade jdc-fade-3">
    <div className="text-center mb-12">
      <p className="text-xs font-bold tracking-widest uppercase text-emerald-400 mb-3">Built For Every Hiring Context</p>
      <h2 className="text-3xl font-bold text-slate-100 tracking-tight">Who Codex Is Designed For</h2>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

      {/* Growth-Stage & Scale-Ups — tall left column */}
      <div className="jdc-bento-card md:row-span-2 rounded-2xl border border-amber-800/40 hover:border-amber-500/50 bg-slate-900 p-8 flex flex-col"
        style={{ background: "radial-gradient(ellipse at 30% 80%, rgba(251,146,60,0.07) 0%, transparent 60%), #0f172a" }}>
        <div className="flex justify-center py-2 mb-6">
          <AccentScaleUp />
        </div>
        <h3 className="text-amber-400 font-bold text-xl tracking-tight mb-3">Growth-Stage & Scale-Ups</h3>
        <p className="text-slate-300 text-sm leading-relaxed mb-5">
          Build repeatable hiring infrastructure before inconsistency becomes a liability. Define roles precisely and evaluate fairly — at the speed your growth demands.
        </p>
        <div className="space-y-3 flex-1">
          {["Structure your first 10 hires the same way you'd structure your 100th — with zero HR overhead",
            "Replace ad-hoc role briefs with precise blueprints that align founders, managers, and recruiters instantly",
            "Evaluate every candidate against the same criteria — before bias or urgency distorts the decision"].map((pt, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="w-1.5 h-1.5 rounded-full bg-amber-400 mt-1.5 flex-shrink-0" />
                <p className="text-slate-400 text-sm leading-relaxed">{pt}</p>
              </div>
            ))}
        </div>
        <div className="mt-6 pt-5 border-t border-amber-800/30">
          <div className="flex items-center gap-3 text-xs text-amber-400/60 font-semibold tracking-widest uppercase">
            <div className="w-8 h-0.5 bg-amber-400/30" /> Primary User Group
          </div>
        </div>
      </div>

      {/* Enterprise Organizations */}
      <div className="jdc-bento-card rounded-2xl border border-violet-800/40 hover:border-violet-500/50 bg-slate-900 p-8 flex flex-col"
        style={{ background: "radial-gradient(ellipse at 80% 20%, rgba(168,85,247,0.07) 0%, transparent 60%), #0f172a" }}>
        <div className="flex justify-start mb-5">
          <AccentEnterprise />
        </div>
        <h3 className="text-violet-400 font-bold text-xl tracking-tight mb-3">Enterprise Organizations</h3>
        <p className="text-slate-300 text-sm leading-relaxed mb-4">
          Standardize hiring intelligence across business units, geographies, and seniority bands — with compliance, governance, and audit readiness built in from day one.
        </p>
        <div className="mt-auto bg-violet-900/10 border border-violet-800/30 rounded-lg p-3">
          <p className="text-violet-300 text-xs font-semibold mb-1">Key Benefit</p>
          <p className="text-slate-400 text-xs leading-relaxed">Consistent role standards and defensible hiring decisions across every team and region</p>
        </div>
      </div>

      {/* Recruitment & Staffing Agencies */}
      <div className="jdc-bento-card rounded-2xl border border-cyan-800/40 hover:border-cyan-500/50 bg-slate-900 p-8 flex flex-col"
        style={{ background: "radial-gradient(ellipse at 50% 90%, rgba(34,211,238,0.07) 0%, transparent 60%), #0f172a" }}>
        <div className="flex justify-start mb-5">
          <AccentAgency />
        </div>
        <h3 className="text-cyan-400 font-bold text-xl tracking-tight mb-3">Recruitment & Staffing Agencies</h3>
        <p className="text-slate-300 text-sm leading-relaxed mb-4">
          Process more mandates with greater precision — without scaling headcount. Turn every client brief into a structured, matchable role definition in minutes.
        </p>
        <div className="mt-auto flex items-center gap-6">
          <div className="text-center">
            <div className="text-cyan-400 font-bold text-2xl mb-1">10×</div>
            <div className="text-slate-500 text-xs">Faster Shortlisting</div>
          </div>
          <div className="w-px h-10 bg-cyan-800/40" />
          <div className="text-center">
            <div className="text-cyan-400 font-bold text-2xl mb-1">Zero</div>
            <div className="text-slate-500 text-xs">Manual Extraction</div>
          </div>
        </div>
      </div>

      {/* Consulting & Professional Services — wide */}
      <div className="jdc-bento-card md:col-span-2 rounded-2xl border border-emerald-800/35 hover:border-emerald-500/45 bg-slate-900 p-8"
        style={{ background: "radial-gradient(ellipse at 90% 50%, rgba(16,185,129,0.07) 0%, transparent 60%), #0f172a" }}>
        <div className="flex flex-col md:flex-row md:items-start md:gap-8">
          <div className="flex-shrink-0 mb-5 md:mb-0 md:pt-1">
            <AccentConsulting />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="text-emerald-400 font-bold text-xl tracking-tight mb-3">Consulting & Professional Services</h3>
            <p className="text-slate-300 text-sm leading-relaxed mb-5">
              Define, post, and evaluate roles rapidly as mandates and engagements shift — with audit-ready documentation and structured evaluation at every step.
            </p>
            <div className="flex flex-wrap gap-2">
              {["Multi-Client Ready", "Audit-Ready Docs", "Rapid Role Turnover", "Structured Evaluation"].map((tag, i) => (
                <div key={i} className="px-3 py-1.5 rounded-full bg-emerald-900/20 border border-emerald-800/30">
                  <span className="text-emerald-300 text-xs font-semibold">{tag}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>
);

// ── PROCESS FLOW — context-specific accents, no absolute positioning ──────────
const ProcessFlow = () => {
  const accents = [PfDefine, PfStructure, PfMatch, PfDecide];
  return (
    <section className="jdc-fade jdc-fade-4">
      <div className="text-center mb-12">
        <p className="text-xs font-bold tracking-widest uppercase text-pink-400 mb-3">Intelligence Pipeline</p>
        <h2 className="text-3xl font-bold text-slate-100 tracking-tight">How HEKA Codex Works</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
        {FLOW_STEPS.map((step, i) => {
          const Accent = accents[i];
          return (
            <div key={i} className="cdx-process-card rounded-2xl border border-slate-700/40 bg-slate-900/60 p-7 backdrop-blur-sm overflow-hidden group"
              style={{ borderTop: `2px solid ${step.color}35` }}>
              {/* Accent centred at top — full width, content below */}
              <div className="flex justify-center mb-5 opacity-65 group-hover:opacity-100 transition-opacity duration-300">
                <Accent />
              </div>
              <div className="text-sm font-bold tracking-widest uppercase mb-2" style={{ color: step.color }}>
                {step.label}
              </div>
              <p className="text-slate-300 text-sm leading-relaxed">{step.description}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

const ComparisonTable = () => (
  <section className="jdc-fade jdc-fade-4">
    <div className="text-center mb-12">
      <h2 className="text-3xl font-bold text-slate-100 tracking-tight mb-4">{COMPARISON.title}</h2>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
      <div className="jdc-comparison-card rounded-2xl border border-red-800/30 bg-gradient-to-br from-red-900/10 to-slate-900/50 p-8 backdrop-blur-sm group">
        <h3 className="text-red-400 font-bold text-xl mb-6 flex items-center gap-2"><span className="text-2xl">❌</span> {COMPARISON.beforeTitle}</h3>
        <div className="space-y-4">
          {COMPARISON.before.map((item, i) => (
            <div key={i} className="jdc-comparison-item flex items-start gap-3">
              <Icon d={ICONS.x} size={18} className="text-red-400 flex-shrink-0 mt-0.5 jdc-x-icon" />
              <p className="text-slate-400 text-sm leading-relaxed">{item}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="jdc-comparison-card rounded-2xl border border-emerald-800/30 bg-gradient-to-br from-emerald-900/10 to-slate-900/50 p-8 backdrop-blur-sm group">
        <h3 className="text-emerald-400 font-bold text-xl mb-6 flex items-center gap-2"><span className="text-2xl">✅</span> {COMPARISON.afterTitle}</h3>
        <div className="space-y-4">
          {COMPARISON.after.map((item, i) => (
            <div key={i} className="jdc-comparison-item flex items-start gap-3">
              <Icon d={ICONS.check} size={18} className="text-emerald-400 flex-shrink-0 mt-0.5 jdc-check-icon" style={{ animationDelay: `${i * 0.1}s` }} />
              <p className="text-slate-300 text-sm leading-relaxed">{item}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

const HiringTimeline = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setVisible(true); obs.disconnect(); } }, { threshold: 0.15 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} className="jdc-fade jdc-fade-5">
      <div className="text-center mb-16">
        <p className="text-xs font-bold tracking-widest uppercase text-orange-400 mb-3">End-to-End System</p>
        <h2 className="text-3xl font-bold text-slate-100 tracking-tight">The Hiring Intelligence Cycle</h2>
        <p className="text-slate-400 mt-4 max-w-xl mx-auto text-sm leading-relaxed">
          From the first role idea to a confident hiring decision — every stage powered by structured intelligence.
        </p>
      </div>

      {/* Desktop */}
      <div className="hidden lg:block relative">
        <div className="absolute top-[20px] left-[5%] right-[5%] h-0.5">
          <div className="h-full w-full bg-gradient-to-r from-orange-500/20 via-violet-500/30 via-cyan-500/30 via-emerald-500/30 to-amber-500/20 cdx-glow-trail" />
        </div>
        <div className="absolute top-[20px] left-[5%] right-[5%] h-0.5 bg-gradient-to-r from-orange-400 via-violet-400 via-cyan-400 via-emerald-400 to-amber-400 origin-left cdx-h-timeline-line" />
        <div className="grid grid-cols-5 gap-4 px-4">
          {TIMELINE_STEPS.map((item, i) => (
            <div key={i} className="flex flex-col items-center"
              style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(20px)', transition: `all 0.6s ease ${0.4 + i * 0.15}s` }}>
              <div className="mb-5 w-10 h-10 rounded-full border-2 flex items-center justify-center z-10"
                style={{ borderColor: item.nodeColor, backgroundColor: `${item.nodeColor}18`, boxShadow: visible ? `0 0 14px ${item.nodeColor}55` : 'none', transition: `box-shadow 0.5s ease ${0.6 + i * 0.15}s` }}>
                <div className="w-3 h-3 rounded-full" style={{ backgroundColor: item.nodeColor }} />
              </div>
              <div className="cdx-tl-card w-full rounded-xl p-5 backdrop-blur-sm"
                style={{ border: `1px solid ${item.border}`, background: `radial-gradient(ellipse at 50% 0%, ${item.glowColor} 0%, transparent 70%), #0f172acc` }}>
                <div className="text-xs font-bold tracking-widest mb-1.5" style={{ color: item.color }}>STEP {item.step}</div>
                <h4 className="text-slate-100 font-bold text-sm mb-1 leading-tight">{item.title}</h4>
                <div className="text-xs mb-3 font-medium" style={{ color: `${item.color}90` }}>{item.subtitle}</div>
                <p className="text-slate-400 text-xs leading-relaxed">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Mobile */}
      <div className="lg:hidden relative pl-8">
        <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-gradient-to-b from-orange-400/40 via-violet-400/40 via-cyan-400/40 via-emerald-400/40 to-amber-400/40 jdc-timeline-line" />
        <div className="space-y-5">
          {TIMELINE_STEPS.map((item, i) => (
            <div key={i} className="relative"
              style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateX(0)' : 'translateX(-16px)', transition: `all 0.5s ease ${0.3 + i * 0.12}s` }}>
              <div className="absolute -left-[22px] top-3 w-4 h-4 rounded-full border-2 flex items-center justify-center"
                style={{ borderColor: item.nodeColor, backgroundColor: `${item.nodeColor}20` }}>
                <div className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: item.nodeColor }} />
              </div>
              <div className="jdc-timeline-card rounded-xl p-5 backdrop-blur-sm"
                style={{ border: `1px solid ${item.border}`, background: `radial-gradient(ellipse at 0% 50%, ${item.glowColor} 0%, transparent 70%), #0f172acc` }}>
                <div className="text-xs font-bold tracking-widest mb-1" style={{ color: item.color }}>{item.title}</div>
                <div className="text-xs mb-2 font-medium" style={{ color: `${item.color}80` }}>{item.subtitle}</div>
                <p className="text-slate-400 text-xs leading-relaxed">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const HekaCodex = ({ setCurrentPage = () => { } }) => (
  <>
    <style>{styles}</style>
    <div className="min-h-screen bg-slate-950 text-slate-100">
      <div className="space-y-28 max-w-6xl mx-auto px-4 pb-20">
        <section className="relative pt-24 pb-16 text-center jdc-fade jdc-fade-1">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-orange-600/40 bg-orange-900/15 mb-6 backdrop-blur-sm">
            <span className="w-2 h-2 rounded-full bg-orange-400 animate-pulse" />
            <span className="text-orange-400 text-xs font-bold tracking-widest uppercase">Role Intelligence Workspace</span>
          </div>

          <h1 className="text-5xl md:text-7xl font-extrabold leading-tight mb-3">
            <span className="vp-title">Heka CODEX</span>
          </h1>
          <p className="text-slate-300 text-2xl md:text-3xl font-bold tracking-wide mt-2 mb-6">
            Inscribe the Role. Summon the Match.
          </p>

          <p className="text-slate-400 max-w-2xl mx-auto text-lg leading-relaxed mb-8">
            From vague role ideas to precision-defined job architecture — HEKA Codex parses documents, maps skills, and standardizes every hiring decision into a repeatable, data-backed system.
          </p>
          <div className="text-sm tracking-wide text-orange-300/70">Built for Recruiters, Hiring Managers & Talent Operations Teams</div>
        </section>

        <div className="jdc-divider" />
        <FeatureGrid />
        <div className="jdc-divider" />
        <BentoCards />
        <div className="jdc-divider" />
        <HiringTimeline />
        <div className="jdc-divider" />
        <ComparisonTable />
        <div className="jdc-divider" />
        {/* ── CTA SECTION ─────────────────────────────────── */}
        <section className="api-fade api-fade-2 text-center p-12 rounded-2xl bg-gradient-to-br from-amber-900/20 to-violet-900/20 border border-amber-800/30 max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-amber-400 mb-4">
            Ready to Build Your Role Blueprint?
          </h2>
          <p className="text-violet-300 mb-8 max-w-2xl mx-auto">
            Talk to our team about deploying Codex's role intelligence engine — 
            from JD generation and resume parsing to AI interviews and bias-free evaluation frameworks.
          </p>
          
          <a href="https://wa.me/919235327048?text=Hi%2C%20I%27m%20interested%20in%20HEKA%20Codex%20for%20role%20blueprinting%20and%20structured%20hiring%20workflows.%20I%27d%20like%20to%20learn%20more." 
            target="_blank" rel="noopener noreferrer"
            className="api-btn inline-flex items-center gap-2 bg-amber-600 text-black px-8 py-3 rounded-lg font-bold no-underline text-sm">
            <Icon d={ICONS.whatsapp} size={16} />
            Chat With Our Team
          </a>
        </section>
      </div>
    </div>
  </>
);

export default HekaCodex;